import React from 'react';

import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Grid, Container } from '@material-ui/core';

import Icons from 'consts/icons';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import { HEIGHT_UNITS } from 'consts/units';
import ButtonsUseStyles from 'consts/styles/Buttons';
import Tooltip from '@material-ui/core/Tooltip';
import { formStyles } from 'consts/styles/Form';
import { EditZone } from './private';

const DashboardZoneDetails = props => {
  const { zoneToDisplay, zoomToZone, select } = props;
  const selectedZones = useSelector(state => state.selectedZones);

  const subtitles = useSelector(state => state.language).zonesDetails;
  const [zoneToEdit, setZoneToEdit] = React.useState(null);
  const userSettingObject = UserSessionDataHandler.getUserSettingsObject();
  const lang =
    userSettingObject &&
    userSettingObject[UserSessionDataHandler.defaultLanguage]
      ? userSettingObject[UserSessionDataHandler.defaultLanguage]
      : 'en';

  const classesButtons = ButtonsUseStyles();
  const formClasses = formStyles();

  return (
    <Grid
      container
      className={`${formClasses.Form}__overflow-component ${formClasses.Form}--flex ${formClasses.Form}--flex--direction ${formClasses.Form}--flex--flex-end`}
    >
      <Container>
        <Grid
          container
          spacing={1}
          className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between`}
        >
          <Grid item xs={3}>
            <Icons.DashboardMenu.Map
              className={`${formClasses.Form}__icon--big ${formClasses.Form}__text-field--black ${formClasses.Form}--invert--black`}
            />
          </Grid>
          <Grid item xs={7}>
            <div className={`${formClasses.Form}__label`}>
              {`${subtitles.uid_}: `}
              <span
                className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
              >
                {zoneToDisplay.uid}
              </span>
            </div>
          </Grid>
          <Grid
            item
            xs={2}
            align="right"
            className={`${formClasses.Form}--flex ${
              selectedZones.length > 1
                ? `${formClasses.Form}--flex--between`
                : `${formClasses.Form}--flex--flex-end`
            }`}
          >
            <Tooltip title={subtitles.zoom_} placement="right">
              <Button
                type="button"
                fullWidth
                onClick={() => zoomToZone(zoneToDisplay.geojson)}
                className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}--mid ${classesButtons.ButtonsCircle}`}
              >
                <Icons.Zoom.ZoomInOnMap />
              </Button>
            </Tooltip>
            {selectedZones.length > 1 ? (
              <div>
                <Tooltip title={subtitles.button_} placement="right">
                  <Button
                    type="button"
                    fullWidth
                    onClick={() => select(zoneToDisplay.uid)}
                    className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}--mid ${classesButtons.ButtonsCircle}`}
                  >
                    <Icons.Zoom.ZoomIn />
                  </Button>
                </Tooltip>
              </div>
            ) : null}
            <Tooltip title={subtitles.editZone_}>
              <Button
                type="button"
                fullWidth
                onClick={() => setZoneToEdit(true)}
                className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}--mid ${classesButtons.ButtonsCircle}`}
              >
                <Icons.Actions.Edit2 />
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid
          container
          spacing={1}
          className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between ${formClasses.Form}--height--dashboard-min-height`}
        >
          <Grid item xs={6}>
            <span className={`${formClasses.Form}__label`}>
              {subtitles.name_}
            </span>
            <br />
            <span
              className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
            >
              {zoneToDisplay.name || zoneToDisplay.othername}
            </span>
          </Grid>
          <Grid item xs={6}>
            <span className={`${formClasses.Form}__label`}>
              {subtitles.type_}
            </span>
            <br />
            <span
              className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
            >
              {zoneToDisplay.type}
            </span>
          </Grid>

          <Grid item xs={6}>
            <span className={`${formClasses.Form}__label`}>
              {subtitles.heightMin_}
            </span>
            <br />
            <span
              className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
            >
              {zoneToDisplay.amsl_min
                ? `${zoneToDisplay.amsl_min} ${HEIGHT_UNITS.feets}`
                : `${zoneToDisplay.agl_min} ${HEIGHT_UNITS.meters}`}
            </span>
          </Grid>
          <Grid item xs={6}>
            <span className={`${formClasses.Form}__label`}>
              {subtitles.heightMax_}
            </span>
            <br />
            <span
              className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
            >
              {zoneToDisplay.amsl_max
                ? `${zoneToDisplay.amsl_max} ${HEIGHT_UNITS.feets}`
                : `${zoneToDisplay.agl_max} ${HEIGHT_UNITS.meters}`}
            </span>
          </Grid>

          <Grid item xs={12}>
            <span className={`${formClasses.Form}__label`}>
              {subtitles.description_}
            </span>
            <br />
            <span
              className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
            >
              {zoneToDisplay.description
                ? zoneToDisplay.description[lang]
                : '-'}
            </span>
          </Grid>

          <Grid item xs={6}>
            <span className={`${formClasses.Form}__label`}>
              {subtitles.visibilityType_}
            </span>
            <br />
            <span
              className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
            >
              {zoneToDisplay.visibility ? (
                <>
                  <Icons.Filters.ButtonPrivate /> {subtitles.private_}
                </>
              ) : (
                <>
                  <Icons.Filters.ButtonPublic /> {subtitles.public_}
                </>
              )}
            </span>
          </Grid>
          <Grid item xs={6}>
            <span className={`${formClasses.Form}__label`}>
              {subtitles.activityType_}
            </span>
            <br />
            <span
              className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
            >
              {zoneToDisplay.active ? (
                <>
                  <Icons.Filters.ActionSuccess />
                  {subtitles.activeYes_}
                </>
              ) : (
                <>
                  <Icons.Filters.ActionFail />
                  {subtitles.activeNo_}
                </>
              )}
            </span>
          </Grid>

          <Grid item xs={6}>
            <span className={`${formClasses.Form}__label`}>
              {subtitles.contact_}
            </span>
            <br />
            <span
              className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
            >
              {zoneToDisplay.contact || '-'}
            </span>
          </Grid>
        </Grid>

        {!!zoneToEdit && (
          <EditZone zoneToEdit={zoneToDisplay} setOpenModal={setZoneToEdit} />
        )}
      </Container>
    </Grid>
  );
};

DashboardZoneDetails.propTypes = {
  zoneToDisplay: PropTypes.object,
  zoomToZone: PropTypes.func.isRequired,
  select: PropTypes.func.isRequired,
};

export default DashboardZoneDetails;
